import dayjs from 'dayjs'
import type { Iso8601Timestamp } from '~/common/model'

export enum DateFormat {
  ServerDate = 'YYYY-MM-DD',
  ShortDate = 'DD-MM-YYYY',
  MediumDate = 'd MMM YYYY',
  ShortDateTime = 'DD-MM-YYYY HH:mm',
  Time = 'HH:mm',
}

export const formatIsoDate = (isoDate: Iso8601Timestamp, format: DateFormat): string => {
  return dayjs(isoDate).format(format)
}
